/**
 * @file   src\mobile\components\createWantAd\AddCompensation.js
 * @brief  This file is responsible for add compensation in create want ad section
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import ProgressBar from "../v2/ProgressBar";
import {
  setLocalStorage,
  getLocalStorage,
  setBodyBackgroundWhite,
  capitalizeFirstString,
  trimString,
} from "../../../helpers/common";
import {
  ERROR_TEXT,
  WANT_AD_KEY,
  WANT_AD_KEY_TEMP,
} from "../../../constants/common";
import AgentCompensation from "./AgentCompensation";
import TextAreaMob from "../TextAreaMob";
import { handleTextBoxChange } from "../../../actions/common";
import { textValidations } from "../../../helpers/validations";

const AddCompensation = (props) => {
  const {
    completedPercentage,
    handleFormValues,
    formValues,
    setUIKey,
    setCompletedPercentage,
    isAgent,
    isEdit,
  } = props;

  const [disableSave, setDisableSave] = useState(false);
  const agentCompenation = _.get(formValues, "agentCompenation", null);
  const agentCompenationInSession = _.get(
    getLocalStorage(WANT_AD_KEY),
    "agentCompenation",
    "",
  );
  const otherConcessionsInSession = _.get(
    getLocalStorage(WANT_AD_KEY),
    "otherConcessions",
    "",
  );

  const otherConcessions = _.get(formValues, "otherConcessions", null);
  const [compensationError, setCompensationError] = useState("");
  const [otherConcessionError, setOtherConcessionError] = useState("");
  const [descCursorPos, setDescCursorPos] = useState(0);
  const [descCharCount, setDescCharCount] = useState(0);
  const OtherConcessionRef = useRef();

  useEffect(() => {
    setBodyBackgroundWhite();
  }, []);
  /**
   * To handle validation
   * @returns
   */
  const validate = () => {
    setCompensationError("");
    let errorExist = false;
    if (otherConcessions && !textValidations(otherConcessions)) {
      setOtherConcessionError(ERROR_TEXT);
      errorExist = true;
    }
    if (errorExist) {
      return false;
    }
    return true;
  };
  /**
   * To convert to sentence case
   * @param {*} input
   * @param {*} lowercaseBefore
   * @returns
   */
  const sentenceCase = (input, lowercaseBefore) => {
    setOtherConcessionError("");
    input = input === undefined || input === null ? "" : input;
    if (lowercaseBefore) {
      input = input.toLowerCase();
    }
    return input
      .toString()
      .replace(/(^|\. *)([a-z])/g, function (match, separator, char) {
        return separator + char.toUpperCase();
      });
  };
  /**
   * To handle changes in other concessions field
   * @param {*} e
   */
  const handleOtherOncessionChange = (e) => {
    let value = capitalizeFirstString(handleTextBoxChange(e));
    console.log("value", value);

    value = sentenceCase(value);
    setDescCharCount(value.length);
    if (trimString(value) !== "") {
      handleFormValues({ otherConcessions: value });
      setDescCursorPos(e.target.selectionStart);
    } else {
      handleFormValues({ otherConcessions: "" });
    }
  };

  return (
    <>
      <div className="gitcha-main-wrapper pb-102 bg-white">
        <div className="content-wrapper content-wrapper-h-100-percent">
          <ProgressBar
            completedPercentage={completedPercentage}
            setUIKey={setUIKey}
            isEdit={isEdit}
            isFromAddCompensation={true}
          />
          <div className="inner-layout-content h-100 bg-white">
            <div className="premium-content-wrapper pe-3 ps-3 pt-4 bg-white h-100">
              <div className="top-three-comp-btm-sec mt-0 mb-4">
                <h2>Buyer Requested Concessions</h2>
              </div>
              <>
                {/* <AgentCompensation
                  handleFormValues={handleFormValues}
                  agentCompenation={agentCompenation}
                  compenationType={compenationType}
                  compensationError={compensationError}
                /> */}
                <div className="col-12 ">
                  <div className="mb-4 position-relative">
                    <TextAreaMob
                      className="form-control txtAreaStyle"
                      value={otherConcessions ? otherConcessions : ""}
                      errorMessage={otherConcessionError}
                      maxLength={500}
                      placeholder="Rate buy down, closing costs, etc."
                      onChange={(e) => {
                        handleOtherOncessionChange(e);
                      }}
                      txtRef={OtherConcessionRef}
                    ></TextAreaMob>
                    <div className="text-end fnt10 pt-1 des-count-mob des-count-157">
                      {descCharCount}/500
                    </div>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
        <div className="inner-layout-footer-new">
          <div className="inner-btm-fixed-nav ">
            <div className="btn-wrap text-center pb-40 pt-0">
              <button
                type="button"
                className="btn btn-primary w-100 mb-0"
                disabled={disableSave}
                onClick={() => {
                  if (validate()) {
                    if (isAgent) {
                      if (completedPercentage > 70) {
                        setCompletedPercentage(completedPercentage);
                      } else {
                        setCompletedPercentage(70);
                      }
                    } else {
                      if (completedPercentage > 85) {
                        setCompletedPercentage(completedPercentage);
                      } else {
                        setCompletedPercentage(85);
                      }
                    }
                    setTimeout(() => {
                      setLocalStorage(
                        WANT_AD_KEY,
                        getLocalStorage(WANT_AD_KEY_TEMP),
                      );
                      if (!isEdit) {
                        setUIKey("readyToPost");
                      } else {
                        setUIKey(null);
                      }
                    }, 500);
                  }
                }}
              >
                {isEdit ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompensation;
